import React from 'react';
import { Modal, useModalVariant } from '@chargify/custom-ui-components';
import { useSelector } from '@xstate/react';
import { useServices } from '../../hooks';
import { modalsSelectors } from '../../machines';
import { Content } from './components';

const UndoCancelation = () => {
  const { modalsService } = useServices();
  const modalVariant = useModalVariant();
  const { isOpen, meta } = useSelector(
    modalsService,
    modalsSelectors.getUndoCancelation
  );
  const closeHandler = () => modalsService.send({ type: 'CLOSE_MODAL' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeHandler}
      variant={modalVariant}
      width="100%"
    >
      <Content {...meta} displayMode={modalVariant} onClose={closeHandler} />
    </Modal>
  );
};

export default UndoCancelation;
